function ContentSafeArea({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-[100svh] flex-col pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)] pt-[env(safe-area-inset-top)]">
      <div className="flex min-h-0 flex-1 flex-col pb-[120px] pt-[var(--navigation-bar-height)]">{children}</div>
    </div>
  );
}

export default ContentSafeArea;
